// src/locales/en/nav.js
export const nav = {
    dashboard: "டாஷ்போர்டு",
    orders: "ஆர்டர்கள்",
    onlineOrders: "ஆன்லைன் விற்பனை",
    products: "தயாரிப்புகள்",
    inventory: "சரக்கு",
    procurement: "கொள்முதல்",
    users: "பயனர் நிர்வாகம்",
    shops: "கடைகள்",
    reports: "அறிக்கைகள்",
    settings: "அமைப்புகள்",
    logout: "வெளியேறு",
    profile: "சுயவிவரம்",
    couriers: "கூரியர்கள்"
}